import React from 'react';
import { View, Text, ActivityIndicator } from 'react-native';
import NearbyMap, { NearbySpot } from '../NearbyMap';
import useNearbySpots from '../hooks/useNearbySpots';

export interface NearbyTabProps {
  supabaseClient: any;
  cardId?: string | null;
  coords?: { lat: number; lng: number } | null;
  title?: string;
  address?: string;
  primaryImageUrl?: string;
  onSelectNearby?: (spotId: string) => void;
}

const NearbyTab: React.FC<NearbyTabProps> = ({ supabaseClient, cardId, coords, title, address, primaryImageUrl, onSelectNearby }) => {
  const { spots, loading, error } = useNearbySpots({ supabaseClient, cardId: cardId || undefined, coords: coords || null });

  if (!coords) {
    return <Text style={{ fontSize: 14, color: '#9CA3AF' }}>暂时无法获取该地点的坐标，无法展示附近景点。</Text>;
  }

  return (
    <View style={{ paddingVertical: 4 }}>
      <View style={{ flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <Text style={{ fontSize: 16, fontWeight: '600', color: '#111827' }}>附近景点</Text>
        {loading ? <ActivityIndicator size="small" color="#0B61D6" /> : null}
      </View>
      <NearbyMap
        center={[coords.lat, coords.lng]}
        primaryLabel={title || '当前地点'}
        spots={spots}
        primaryImageUrl={primaryImageUrl}
        primaryName={title}
        primaryAddress={address}
        onSelectSpot={onSelectNearby}
        requireDoubleClick={true}
      />
      {error ? (
        <Text style={{ fontSize: 13, color: '#DC2626', marginTop: 12 }}>{error}</Text>
      ) : (!loading && spots.length === 0) ? (
        <Text style={{ fontSize: 13, color: '#9CA3AF', marginTop: 12 }}>附近暂时没有其他公开卡片。</Text>
      ) : null}
    </View>
  );
};

export default NearbyTab;
